import React from "react";

const VoucherCount = ({ count }) => {
    return <span className="number-indicator">{count}</span>;
};

export default VoucherCount;
